import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge the custom theme tokens from ui.css. Otherwise it reads
// `text-control` as a color and drops it next to `text-white`, and keeps both
// `px-control-inline` and a later `px-*` override.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["control"],
      spacing: ["control-gap", "control-inline", "control-block"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
